/** 来源地址 */
export enum Keyboard {
    /** 退格 */
    BACK_SPACE = 'Backspace',
    /** 键盘方向左 */
    ARROW_LEFT = 'ArrowLeft',
    /** 键盘方向右 */
    ARROW_RIGHT = 'ArrowRight',
}
